<app-header></app-header>
<app-mobile-slider-full></app-mobile-slider-full>
